import { useLang } from '@/i18n';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import EcoCardsB from 'eco-design/sections-test/eco-cards-b';
import EcoShopCardA from 'eco-design/sections-test/eco-shop-card-a';
import { Fragment, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';
import { useProductStore } from '@elem/compPage/wave-3-and-glacier-classic/ProductProvider';
import { IPageStatus } from '@elem/compPage/wave-3-and-glacier-classic/config/IPageStatus';
import EcoEmail from 'eco-design/elements/eco-email';
import { useGlobal } from '@/utils/useGlobal';
import { getScheduledContent } from '@/utils/hooks/useScheduledContent';
export default function Comp() {
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();
    const { t } = useLang('theProduct.ListB2');
    const { pageStatus } = useProductStore();
    const contactListId = ['1578333930'];

    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745206976110/KV.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207295664/KV.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373183763/KSP1%20(2).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207390194/%E6%91%84%E6%B0%8F%E5%BA%A6.jpg',
            desc: t('item1_desc1'),
            title: t('item1_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373185039/KSP1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745207295957/Frame%201612707467%20(1).jpg',
            desc: t('item2_desc1'),
            title: t('item2_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373183586/KSP1%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745378470035/Frame%201000009346.jpg',
            desc: t('item3_desc1'),
            title: t('item3_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745373182522/image%20(2).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745378470244/Frame%201612707468.jpg',
            desc: t('item4_desc1'),
            title: t('item4_title'),
        },
    ];
    const tabObjA = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745204810574/35.png',
        // label: t('card1_label'),
        title: t('card1_title'),
        descList: [t('card1_desc1'), t('card1_desc2'), t('card1_desc3')],
        disabled: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': true,
                '2025/06/01 10:00:00 GMT+8': false,
            },
            systemTime,
        ),
        lChildren: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': t('card1_btn'),
                '2025/06/01 10:00:00 GMT+8': t('card1_btn2'),
            },
            systemTime,
        ),
        lHref: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': '',
                '2025/06/01 10:00:00 GMT+8': 'https://www.ecoflow.com/jp/glacier-classic-portable-refrigerator',
            },
            systemTime,
        ),
    };
    const tabObjB = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745204809374/45.png',
        // label: t('card2_label'),
        title: t('card2_title'),
        descList: [t('card2_desc1'), t('card2_desc2'), t('card2_desc3')],
        disabled: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': true,
                '2025/06/01 10:00:00 GMT+8': false,
            },
            systemTime,
        ),
        lChildren: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': t('card2_btn'),
                '2025/06/01 10:00:00 GMT+8': t('card2_btn2'),
            },
            systemTime,
        ),
        lHref: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': '',
                '2025/06/01 10:00:00 GMT+8': 'https://www.ecoflow.com/jp/glacier-classic-portable-refrigerator',
            },
            systemTime,
        ),
    };
    const tabObjC = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745204811101/55.png',
        // label: t('card3_label'),
        title: t('card3_title'),
        descList: [t('card3_desc1'), t('card3_desc2'), t('card3_desc3')],
        disabled: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': true,
                '2025/06/01 10:00:00 GMT+8': false,
            },
            systemTime,
        ),
        lChildren: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': t('card3_btn'),
                '2025/06/01 10:00:00 GMT+8': t('card3_btn2'),
            },
            systemTime,
        ),
        lHref: getScheduledContent(
            {
                '2025/05/01 10:00:00 GMT+8': '',
                '2025/06/01 10:00:00 GMT+8': 'https://www.ecoflow.com/jp/glacier-classic-portable-refrigerator',
            },
            systemTime,
        ),
    };
    const tabItemsA = [
        {
            tabValue: 'a1',
            tabLabel: t('card1_tab_label'),
            tabListObj: tabObjA,
        },
        {
            tabValue: 'a2',
            tabLabel: t('card2_tab_label'),
            tabListObj: tabObjB,
        },
        {
            tabValue: 'a3',
            tabLabel: t('card3_tab_label'),
            tabListObj: tabObjC,
        },
    ];
    const [tabActiveObj2, setTabActiveObj2] = useState(tabObjA);
    const tabChange = (item: any, index: number) => {
        setTabActiveObj2(tabItemsA[index].tabListObj);
    };

    return (
        <div className="wave-3-listB2">
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <EcoCardsB items={itemsA} />

            <div className="eco-content">
                <div className="section-ListB2-Email">
                    <div className="section-l-title">
                        {t.rich(
                            getScheduledContent(
                                {
                                    '2025/05/01 10:00:00 GMT+8': 'email_text',
                                    '2025/06/01 10:00:00 GMT+8': 'email_text_6_1',
                                },
                                systemTime,
                            ),
                            {
                                a1: (a: any) => {
                                    return (
                                        <a href="https://jp.ecoflow.com/products/ecoflow-power-hat?_pos=1&_sid=4d1f68070&_ss=r" target="_blank">
                                            {a}
                                        </a>
                                    );
                                },
                            },
                        )}
                    </div>
                    <EcoEmail
                        termsHtml='<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">プライバシーポリシー</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank" rel="noopener noreferrer" onclick="event.stopPropagation()">利用規約</a>に同意します。'
                        contactListId={contactListId}
                        defaultTermsCheck
                        tipsObj={{ btnText: t('email_btn'), tipsCheck: t('tipsCheck'), tipsEmpty: 'メールアドレス' }}
                        source="WEB_NEW_PRODUCT_SUB"
                        fields={[
                            {
                                id: '9120',
                                type: 'multiple',
                                value: [32],
                                overwrite: false,
                            },
                            {
                                id: '31',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                            {
                                id: '4431',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                        ]}
                        subscribeData={{
                            sector_name: t('title'),
                            entry_position: 5,
                        }}
                    />
                </div>
            </div>
            <div className={`section-ListB2`}>
                <div className="section-ListB2-pc eco-content">
                    <EcoTab items={tabItemsA} onChange={tabChange} type="round" />
                    <Fragment key={tabActiveObj2.title}>
                        <EcoShopCardA
                            layout="imgR"
                            pc={tabActiveObj2.pc}
                            title={tabActiveObj2.title}
                            desc={tabActiveObj2.descList}
                            lChildren={tabActiveObj2.lChildren}
                            disabled={tabActiveObj2.disabled}
                            lHref={tabActiveObj2.lHref}
                            ldataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: tabActiveObj2.title,
                                position: `Collections_${tabActiveObj2.title}`,
                            }}
                        />
                    </Fragment>
                </div>
                <div className="section-ListB2-h5">
                    <div className="section-ListB2-h5-content">
                        <Swiper
                            slidesPerView={'auto'}
                            spaceBetween={16}
                            navigation={{
                                nextEl: '.eco-swiper-button-next',
                                prevEl: '.eco-swiper-button-prev',
                            }}
                            modules={[Navigation]}
                        >
                            <SwiperSlide>
                                <EcoShopCardA
                                    layout="imgR"
                                    pc={tabObjA.pc}
                                    title={tabObjA.title}
                                    desc={tabObjA.descList}
                                    lChildren={tabObjA.lChildren}
                                    disabled={tabObjA.disabled}
                                    lHref={tabObjA.lHref}
                                    ldataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: tabObjA.title,
                                        position: `Collections_${tabObjA.title}`,
                                    }}
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <EcoShopCardA
                                    layout="imgR"
                                    pc={tabObjB.pc}
                                    title={tabObjB.title}
                                    desc={tabObjB.descList}
                                    lChildren={tabObjB.lChildren}
                                    disabled={tabObjB.disabled}
                                    lHref={tabObjB.lHref}
                                    ldataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: tabObjB.title,
                                        position: `Collections_${tabObjB.title}`,
                                    }}
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <EcoShopCardA
                                    layout="imgR"
                                    pc={tabObjC.pc}
                                    title={tabObjC.title}
                                    desc={tabObjC.descList}
                                    lChildren={tabObjC.lChildren}
                                    disabled={tabObjC.disabled}
                                    lHref={tabObjC.lHref}
                                    ldataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: tabObjC.title,
                                        position: `Collections_${tabObjC.title}`,
                                    }}
                                />
                            </SwiperSlide>
                            <div className={`eco-swiper-control`}>
                                <div className="eco-swiper-navigation">
                                    <div className="eco-swiper-button-prev">
                                        <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                    </div>
                                    <div className="eco-swiper-button-next">
                                        <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                                    </div>
                                </div>
                            </div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}
